import React from 'react'
import { Card, CardBody, Col, FormGroup, Input, Label, Table } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import { grossSalesData } from '../../../Data/Dashboard/Ecommerce'
import { Image, P } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { Link } from 'react-router-dom'

export default function GrossSales() {
    return (
        <Col xxl={7} className="box-col-12">
            <Card className="best-seller">
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Gross Sales "} />
                <CardBody className="pt-0">
                    <div className="table-responsive theme-scrollbar">
                        <div className="dataTables_wrapper no-footer">
                            <div className="dataTables_filter">
                                <label> Search: <input type="search" /></label>
                            </div>
                            <Table className="display dataTable no-footer">
                                <thead>
                                    <tr role="row">
                                        <th className="sorting">
                                            <FormGroup check>
                                                <Input type="checkbox" defaultValue='' />
                                                <Label check />
                                            </FormGroup>
                                        </th>
                                        <th className="sorting">Name</th>
                                        <th className="sorting_asc">Date</th>
                                        <th className="sorting">Product</th>
                                        <th className="sorting">Country</th>
                                        <th className="sorting">Total</th>
                                        <th className="sorting">Status</th>
                                        <th className="sorting">Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {grossSalesData.map((item) => (
                                        <tr role="row" className="even" key={item.id}>
                                            <td className="sorting_1">
                                                <FormGroup check>
                                                    <Input type="checkbox" defaultValue='' />
                                                    <Label check />
                                                </FormGroup>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    {item.id === 1 ? (
                                                        <div className="flex-shrink-0">
                                                            <Image className="img-fluid" src={dynamicImage(`dashboard-2/dash-2/${item.image}`)} alt="" />
                                                        </div>
                                                    ) : (
                                                        <Image className="img-fluid" src={dynamicImage(`dashboard-2/dash-2/${item.image}`)} alt="" />
                                                    )}
                                                    <div className="flex-grow-1">
                                                        <span className="f-14 f-w-600"><Link to={`${process.env.PUBLIC_URL}/users/user_profile`}>{item.name}</Link></span>
                                                        <P className="mb-0">{'2024'}</P>
                                                    </div>
                                                    <div className="active-status active-online" />
                                                </div>
                                            </td>
                                            <td>{item.date}</td>
                                            <td>{item.product}</td>
                                            <td> <i className={`flag-icon flag-icon-${item.flag}`} /></td>
                                            <td> <span>{`$${item.total}`}</span></td>
                                            <td> <span>{'Success'}</span><i className="fa fa-check-circle f-14" /></td>
                                            <td><span> <Link to={`${process.env.PUBLIC_URL}/users/user_edit`}>{'Edit'}</Link></span></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}